<div class="profile-image-wrapper d-flex justify-content-center align-items-center">
  <div class="circle unelectable bg-white rounded-circle">
    @if (imageControl.value) {
      <img class="q-image" alt="user image"
        (error)="reloadImage(imageControl)"
        [src]="imageControl.value"/>
    }
    <ng-container>
      <div
        (click)="openImageModal({field:imageControl, height:270, width:270, imageType:imageType})"
        class="image-icon icon-circle position-absolute d-flex justify-content-center align-items-center cursor-pointer">
        <mat-icon color="primary">camera_alt</mat-icon>
      </div>
      @if (imageControl.value) {
        <div
          class="trash-icon icon-circle position-absolute d-flex justify-content-center align-items-center cursor-pointer"
          (click)="removeImage()">
          <mat-icon color="primary">delete</mat-icon>
        </div>
      }
    </ng-container>
    @if (!imageControl.value) {
      <app-image-placeholder [imageData]="{
            image: imageControl.value,
            title:profileName,
            radius: '140px'}"></app-image-placeholder>
    }
  </div>

</div>
